export const FETCH_FILTER_REQUEST=`FETCH_FILTER`;
export const FETCH_FILTER_SUCCESS=`FETCH_FILTER_SUCCESS`;
export const FETCH_FILTER_ERROR=`FETCH_FILTER_ERROR`;
export const APPLY_FILTER=`APPLY_FILTER`;
